<template>
  <section>
    <div class="row mt-2">
      <div class="col-md-9" />
      <div class="col-md-3">
        <input type="text" placeholder="Search Tasks" class="form-control" v-model="search"/>
      </div>
    </div>
    <div class="row task-container mt-4">
      <div class="col-md-12">
        <table class="table table-striped task-table" :id="tableId">
          <thead>
          <tr>
            <th></th>
            <th>Name</th>
            <th>Email</th>
            <!--          <th>Plan</th>-->
            <th>Traffic Limit</th>
            <th>Current Traffic</th>
            <th>Over Traffic %</th>
            <th>Ticket</th>
            <th class="text-center">Snooze</th>
            <th class="text-center">Action <i class="fa fa-bolt"></i></th>
          </tr>
          </thead>
          <tbody v-for="group in paginatedGroups" :key="group.uid">
          <tr>
            <td>
              <span :class="{ 'details-control shown' : group.show, 'details-control' : !group.show }" @click="group.show = !group.show"></span>
            </td>
            <td><b>
              {{group.name }}
            </b></td>
            <td ><b>
              {{group.email }}
            </b></td>
            <!--          <td></td>-->
            <td>{{group.max.totalVisitors}}</td>
            <td>{{group.max.currentVisitors}}</td>
            <td>{{getPercentage(group.max)}}%</td>
            <td>
              <span class="text-primary" title="Add Tickets" @click="openModal(group.max)"> <i class=" fa fa-pencil cursor-pointer"></i></span>
              <span class="text-primary" title="View ticket" v-if="group.max.ticket" @click="openTicket(group.max)"> <i class=" fa fa-eye cursor-pointer ml-2"></i></span>
            </td>
            <td>
              <select style="height: 31px" class="form-control" @change="selectSnoozeValue(group.max, $event)">
                <option>Select</option>
                <option value="1 day">1 day</option>
                <option value="1 week">1 week</option>
                <option value="1 month">1 month</option>
                <option value="3 months">3 month</option>
                <option value="forever">Forever</option>
              </select>
            </td>
            <td>
              <button title="Login as user" class="btn btn-primary btn-sm ml-2" @click="loginAsUser(group)">
                <i class="fa fa-user"></i>
              </button>
<!--              <button title="Resolve" @click="resolve(group.max)" class="btn btn-success btn-sm ml-2">-->
<!--                <i class=" fa fa-check cursor-pointer"></i>-->
<!--              </button>-->
<!--              <button title="Create Ticket" @click="openTicketModal(group.max)" class="btn btn-primary btn-sm ml-2">-->
<!--                <i class=" fa fa-envelope cursor-pointer"></i>-->
<!--              </button>-->
            </td>
          </tr>
          <tr v-if="group.show" style="background-color: rgba(251,198, 88, 0.1)" v-for="(row,index) in group.records" :key="index">
            <td></td>
            <td><b>{{ `${getMonthName(row.month)}-${row.year}`}}</b></td>
            <td>
              {{row.planName}}
            </td>
            <!--          <td>{{row.planName}}</td>-->
            <td>{{row.totalVisitors}}</td>
            <td>{{row.currentVisitors}}</td>
            <td>{{getPercentage(row)}}%</td>
            <td>
              <span class="text-primary" title="Add Tickets" @click="openModal(row)"> <i class=" fa fa-pencil cursor-pointer"></i></span>
              <span class="text-primary" title="View ticket" v-if="row.ticket" @click="openTicket(row)"> <i class=" fa fa-eye cursor-pointer ml-2"></i></span>
            </td>
            <td width="10%"><select style="height: 31px" class="form-control" @change="selectSnoozeValue(row, $event)">
              <option>Select</option>
              <option value="1 day">1 day</option>
              <option value="1 week">1 week</option>
              <option value="1 month">1 month</option>
              <option value="3 months">3 month</option>
              <option value="forever">Forever</option>
            </select></td>
            <td width="15%">
              <button title="Resolve" @click="resolve(row)" class="btn btn-success btn-sm ml-2">
                <i class=" fa fa-check cursor-pointer"></i>
              </button>
              <button title="Create Ticket" @click="openTicketModal(row)" class="btn btn-primary btn-sm ml-2">
                <i class=" fa fa-envelope cursor-pointer"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row mt-2" v-if="groups.length > 0">
      <div class="col-md-12 text-center">
                    <span class="lh-3 pull-left">
                        Page {{this.pageNumber + 1}} of {{pageCount}}
                    </span>
        <section class="dataTables_paginate paging_full_numbers">
          <paginate
              :pageCount="pageCount"
              :clickHandler="goToPage"
              :prevText="'Prev'"
              :nextText="'Next'"
              page-class="page-item"
              prev-class="page-item"
              prev-link-class="page-link"
              next-class="page-item"
              next-link-class="page-link"
              page-link-class="page-link"
              containerClass="pagination">
          </paginate>
        </section>
      </div>
    </div>
    <div class="customer-list-info" v-if="groups.length === 0">
      <div class="card-text text-center text-danger mb-3 font-weight-bold">
        No Records Exists!
      </div>
    </div>
    <div class="modal" tabindex="-1" role="dialog" id="addTicketModal" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">ADD TICKET</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Ticket</label>
              <textarea class="form-control" v-model="selectedRow.ticket"></textarea>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
            <button class="btn btn-outline-info btn-sm" :disabled="loading"  @click="addTicket()">
              <div class="loader mini_loader" v-if="loading"></div>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <traffic-modal ref="trafficTicketModal"/>
  </section>

</template>

<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";
import Paginate from 'vuejs-paginate'

export default {
  name: "Traffic",
  components: {
    Paginate,
    trafficModal: () => import(/* webpackChunkName: "userList" */ "../../../components/Admin/Tasks/trafficTicketModal")
  },
  props: {
    tableId: {
      type: String
    }
  },
  data() {
    return {
      traffic: [],
      loading: false,
      selectedRow: {},
      presetMacros: [],
      pageNumber: 0,
      search: '',
      pageSize: 10,
      monthArray: [{key: 1, value: 'Jan'},
        {key: 2, value: 'Feb'},
        {key: 3, value: 'Mar'},
        {key: 4, value: 'Apr'},
        {key: 5, value: 'May'},
        {key: 6, value: 'Jun'},
        {key: 7, value: 'Jul'},
        {key: 8, value: 'Aug'},
        {key: 9, value: 'Sep'},
        {key: 10, value: 'Oct'},
        {key: 11, value: 'Nov'},
        {key: 12, value: 'Dec'},
      ],
      groups: []
    }
  },
  async mounted(){
    await this.getTrafficData()
    await this.getPresetReplies()
    this.initDataTable()
  },
  computed: {
    pageCount(){
      let l = this.groups.length, s = this.pageSize;
      return Math.ceil(l/s);
    },
    paginatedGroups () {
      const start = this.pageNumber * this.pageSize, end = start + this.pageSize;
      return this.groups.slice(start, end);
    }
  },
  watch: {
    search () {
      this.createGroups()
    }
  },
  methods: {
    goToPage(pageNum) {
      this.pageNumber = pageNum-1;
    },
    getMonthName (number) {
      const month = this.monthArray.find(m => Number(m.key) === Number(number))
      return month.value
    },
    async getPresetReplies(){
      this.presetMacros=[]
      let result=await db.collection("permissions")
          .doc("preset_macros_traffic")
          .get();
      if(result.exists){
        this.presetMacros = result.data().replies;
      }
    },
    openTicketModal(row){
      this.$refs.trafficTicketModal.load(this.presetMacros, row)
    },
    createGroups () {
      this.pageNumber = 0
      const filteredTrafficRecords = this.traffic.filter(t => t.name.toLowerCase().includes(this.search.toLowerCase()) || t.email.toLowerCase().includes(this.search.toLowerCase()))
      const array = []
      filteredTrafficRecords.forEach(tData => {
        const alreadyExist = array.find(g => g.uid === tData.uid)
        if (alreadyExist) {
          alreadyExist.records.push(tData)
          if (alreadyExist.max && Number(alreadyExist.max.currentVisitors) < Number(tData.currentVisitors)) {
            alreadyExist.max = tData
          }
        } else {
          array.push({
            uid: tData.uid,
            email: tData.email,
            name: tData.name,
            show: false,
            max: tData,
            records: [tData]
          })
        }
      })
      this.groups = array;
    },
    async getTrafficData(){
      this.traffic=[]
      let ref=await db.collection('trafficBillings')
          .where('snoozedDate', '<', new Date().toISOString())
          .get()
      if(ref.size){
        ref.forEach(el => {
          this.traffic.push({id: el.id, ...el.data()})
        })
        this.createGroups()
      }
    },
    getPercentage(data){
      return (((Number(data.currentVisitors) - Number(data.totalVisitors))/Number(data.totalVisitors))*100).toFixed(2)
    },
    initDataTable(){
      // $(`#${this.tableId}`).DataTable({
      //   pagingType: "full_numbers",
      //   lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
      //   destroy: true,
      //   retrieve: true,
      //   deferRender: true,
      //   "ordering": true,
      //   stateSave: true,
      //   'columnDefs': [ {
      //     'targets': [6,7, 8], /* column index */
      //     'orderable': false, /* true or false */
      //   }],
      //   language: {
      //     search: "_INPUT_",
      //     searchPlaceholder: "Search Traffic",
      //     size: 50
      //   }
      // });
    },
    openTicket(row){
      if(row.ticket){
        window.open(row.ticket)
      }
    },
    resolve(row){
      swal({
        title: 'Are you sure?',
        text: 'Are you sure to resolve this?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: "#6ACF98",
        cancelButtonColor: "#EE8057"
      }).then((result) => {
        if(result.value) {
          this.loading = true;
          db.collection('trafficBillings').doc(row.id).delete().then(() => {
            swal('Success!', 'You have successfully resolved!', 'success');
            this.getTrafficData();
          });
        }
      })
    },
    async loginAsUser(data){
      this.loading=true
      const userRef=await db.collection('users').where('email', '==', data.email).limit(1).get()
      let user=null
      if(userRef.size>0){
        userRef.forEach(el => {
          user= {id: el.id, ...el.data()}
        })
        window.open(`https://wpo.bigscoots.com/user/dashboard?id=${user.id}`,'WPO-Bigscoots');
      }else{
        swal('Error!', 'User not found!', 'error');
      }
      this.loading=false
    },
    openModal(data){
      this.selectedRow= data
      $('#addTicketModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    async addTicket(){
      try{
        this.loading=true
        await db.collection('trafficBillings').doc(this.selectedRow.id).update({ticket: this.selectedRow.ticket})
        swal({
          title: "Success!",
          text: "You have successfully added ticket!",
          type: "success"
        })
        $('#addTicketModal').modal('hide');
        this.loading=false
      }
      catch (e){
        this.loading=false
        this.selectedRow=null
        swal({
          title: "Error!",
          text:
              "Something went wrong while adding ticket!",
          type: "error",
          confirmButtonText: "Try Again",
          confirmButtonColor: "#EE8057"
        })
      }
    },
    async selectSnoozeValue(data, e){
      try {
        let date= new Date()
        let val= e.target.value
        if(val === '1 day'){
          date.setDate(date.getDate() + 1)
        }
        else if(val === '1 week') {
          date.setDate(date.getDate() + 7)
        }else if(val === '1 month') {
          date.setMonth(date.getMonth() + 1)
        }else if(val === '3 months') {
          date.setMonth(date.getMonth() + 3)
        }
        else if(val === 'forever'){
          date = null
        }
        console.log(date)
        await db.collection('trafficBillings').doc(data.id).update({snoozedDate: date.toISOString()})
        await this.getTrafficData()
        swal({
          title: "Success!",
          text: "You have successfully snoozed the selected record!",
          type: "success"
        })
      }
      catch (e) {
        swal({
          title: "Error!",
          text: "Something went wrong while snoozing!",
          type: "error",
          confirmButtonText: "Try Again",
          confirmButtonColor: "#EE8057"
        })
      }
    }
  },

}
</script>

<style scoped>

.details-control {
  background: url('../../../assets/img/details_open.png') no-repeat center center;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: block;
  margin: 13px auto;
}

.details-control.shown {
  background: url('../../../assets/img/details_close.png') no-repeat center center;
}
 tr > th,td{
  padding: 4px 7px !important;
   text-align: center!important;
}
 tr > th{
  font-size: 12px !important;
  font-weight: 400 !important;
}
.pagination{
   display: inline-flex !important;
 }
</style>